import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PropTypes from 'prop-types';
import styles from './RightAnswerDialog.module.scss';
import classNames from 'classnames';
import Dialog from './Dialog';
import './TextAppearTransition.scss';

export default class RightAnswerDialog extends Component {
    static propTypes = {
        visible: PropTypes.bool,
        onClose: PropTypes.func.isRequired,
    };

    render() {
        const {visible, onClose, children} = this.props;

        return (
            <Dialog
                visible={visible}
                renderIcon={this.renderIcon}
                okButtonLabel='Next'
                onClose={onClose}
            >
                <ReactCSSTransitionGroup
                    transitionName='text-appear'
                    transitionEnterTimeout={800}
                    transitionLeaveTimeout={800}
                >
                    {children}
                </ReactCSSTransitionGroup>
            </Dialog>
        );
    }

    renderIcon = () => {
        const {visible} = this.props;

        const iconClassName = classNames(styles.rightAnswerIcon, {
            [styles.rightAnswerIconVisibled]: visible,
        });

        return <div className={iconClassName} />;
    };
}
